module.exports = "/_next/static/images/Chicago-guide-hero-0efe941e2ac4feb3e73ec07ed194fe17.png";